import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/create/customer.create.mutation.gql"
import type {
  CustomerCreateMutation,
  CustomerCreateMutationVariables,
} from "@/v2-backoffice-client/customer/create/__types__/customer.create.mutation"

type Options = MutationHookOptions<
  CustomerCreateMutation,
  CustomerCreateMutationVariables
>

export function useCustomerCreateMutation(options?: Options) {
  return useMutation<CustomerCreateMutation, CustomerCreateMutationVariables>(
    mutation,
    options,
  )
}
